<template>
  <div :class="$vuetify.breakpoint.mdAndDown ? 'mobile' : ''">
    <v-row no-gutters justify="space-between">
      <v-col no-gutters cols=10>
        <label style="float:left" class="input-field-label ma-0 text-capitalize d-block">
          {{ $t(`field.captcha`) }}<span v-if="!isOptional" class="red--text ml-1">*</span></label>
      </v-col>
      <v-col no-gutters cols=2></v-col>
      <v-col no-gutters cols=8>
        <v-text-field
            class="input-field elevation-0 hide-details"
            :value="value"
            outlined
            type="text"
            :rules="rules"
            :error-messages="errorMsg"
            @input="input"
            @keydown.space="preventLeadingSpace"
            @keydown.native.space.prevent
            autocomplete="new-password"
            :autofocus="true">
          <template v-slot:append-outer>
            <slot name="form-field-append-outer"></slot>
          </template>
          <template v-slot:append>
            <slot name="form-field-append"></slot>
          </template>
        </v-text-field>
      </v-col>
      <v-col no-gutters cols=4 @click="refreshCaptchaCode" class="captcha-code">
        <captcha-code class="captcha" ref="code" :enable-click="true" text-fill-color="#ffffff" :width="72"></captcha-code>
        <a class="refresh"><v-icon>mdi-refresh</v-icon></a>
      </v-col>
    </v-row>
  </div>
</template>

<script >
import {MEMBER_REQUEST_CAPTCHA_CODE} from "@/store/member.module";

export default {
  name: 'Captcha',
  props: {
    value: {
      required: true,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    rules: {
      type: Array,
      required: false,
      rules: () => []
    },
    isOptional: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMsg: {
      type: String,
      required: false
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.requestCaptchaCode();
      setInterval(this.refreshCaptchaCode, 120000);
    })
  },
  methods: {
    refreshCaptchaCode() {
      this.$refs.code.changeCode();
      this.requestCaptchaCode();
    },
    requestCaptchaCode () {
      let data = {
        captcha_id: this.$refs.code.id,
        captcha_code: this.$refs.code.getCode()
      };
      this.$store.dispatch(`${MEMBER_REQUEST_CAPTCHA_CODE}`, {
        data
      });
    },
    getCode () {
      return this.$refs.code.getCode();
    },
    preventLeadingSpace(e) {
      // only prevent the keypress if the value is blank
      if (!e.target.value) e.preventDefault()
      // otherwise, if the leading character is a space, remove all leading white-space
      else if (e.target.value[0] == ' ') e.target.value = e.target.value.replace(/^\s*/, '')
    },
    input(value) {
      this.$emit('input', value);
    },
  },
  beforeDestroy() {
    clearInterval(this.refreshCaptchaCode);
  },
}
</script>

<style lang="scss">
.v-text-field--outlined {

  fieldset {
    border-width: 1px;
  }
}

.v-text-field--outlined.v-input--is-verify fieldset {
  border-color: var(--v-primary-base);
  border-width: 2px;
}

.input-field-label {
  font-size: 14px;
}

.v-input input,
.v-input textarea,
.theme--dark.v-input input,
.theme--dark.v-input textarea {
  color: var(--v-primary-base);
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin: 0px;
}

.input-field {

  .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
    color: #000000;
  }

  .v-icon,
  .v-input__icon {
    color: #fbb70d;
  }

  .v-input__slot {
    margin: 0px;

    .v-select__slot {
      .v-select__selections {
        color: #000000;

        .v-select__selection--disabled {
          color: #c9c9c9 !important;
        }
      }

      .v-icon--disabled {
        color: #c9c9c9 !important;
      }
    }
  }

  .v-input__append-outer,
  .v-input__prepend-inner {
    margin-top: 0px !important;
    align-self: center;
  }
  .v-input__append-inner {
    margin: 0px;
    align-self: center;
  }

  &.v-input--is-readonly {
    input {
      color: #3A3A3A !important;
      opacity: 0.7;
    }

    .v-input__slot {
      background-color: rgba(0, 0, 0, 0.1);
    }

  }

  .v-input__control {

    .v-input__slot {
      min-height: 40px;
      height: 40px;
    }

    .v-text-field__details {
      margin-bottom: 0px !important;

      .v-messages__message {
        font-size: 11px;
      }
    }
  }
}

.captcha-code {
  display: flex;
  justify-content: flex-end;
  .captcha {
    min-height: 40px;
    height: 40px;
    text-align: center;
    background-color: var(--v-primary-base);
  }

  .refresh {
    display: inline-flex;
    min-height: 40px;
    height: 40px;
    width: 28px;
    background-color: var(--v-primary-base);

    i {
      color: white;
    }
  }
}
</style>
